'use client'

import React from 'react'

export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
        <p className="text-stone-600 font-medium">Loading...</p>
      </div>
    </div>
  )
}

